import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadQuote from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import {
    chain,
    DispatchLoadQuoteIfNeeded,
} from "@insite/client-framework/Store/Pages/RfqConfirmation/Handlers/LoadQuoteIfNeeded";

/**
 * XNG-Changes BG-2996
 * Added `forceReload` to address an issue when navigating back from the Quote List page to the Confirmation page.
 * The API call on the Quote List page was overwriting the quote lines and clearing `lineCollection` values.
 * As a result, product lines were not displayed when returning to the Confirmation page.
 */
export const XngDispatchLoadQuoteIfNeeded: typeof DispatchLoadQuoteIfNeeded = props => {
    const quoteState = getQuoteState(props.getState(), props.parameter.quoteId);
    if (!quoteState.value || (props.parameter as { forceReload?: boolean }).forceReload) {
        props.dispatch(loadQuote({ quoteId: props.parameter.quoteId }));
    }
};

replaceInChain(chain, DispatchLoadQuoteIfNeeded, XngDispatchLoadQuoteIfNeeded);
